// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_na-5";
export var filledCircle = "_na-4";
export var historyEntry = "_na-3";
export var messageSideLeft = "_na-1";
export var messageSideRight = "_na-2";
export var orderTrackingCarouselWrapper = "_na-6";
export var orderTrackingInfoContainer = "_na-0";